import React from 'react';

/* Context */
import { VehicleOverviewContext } from 'js/context';

/* Utilities */
import { trans } from 'js/utilities';

export default class FilterRangeList extends React.Component {
    static contextType = VehicleOverviewContext;

    constructor(props) {
        super(props);

        this.updateFilters = () => { };
    }

    componentDidMount() {
        this.updateFilters = this.context.updateFilters;
    }

    render() {
        const { id, filter, path } = this.props;

        return (
            <div className="row gutters-2">
                <div className="col-12">
                    <select
                        id={`${id}.selectedMinValue`}
                        className="custom-select"
                        value={filter.selectedMinValue}
                        onChange={(event) => {
                            event.persist();
                            this.updateFilters(`${path}.selectedMinValue`, Number(event.target.value));
                        }}
                    >
                        {filter.minValues.map((minValue, index) => (
                            <option key={`${id}.minValues.${index}`} value={minValue}>
                                {trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.min_prefix`, {}, '')}
                                {minValue}
                                {trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.min_suffix`, {}, '')}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-12">
                    <select
                        id={`${id}.selectedMaxValue`}
                        className="custom-select"
                        value={filter.selectedMaxValue}
                        onChange={(event) => {
                            event.persist();
                            this.updateFilters(`${path}.selectedMaxValue`, Number(event.target.value));
                        }}
                    >
                        {filter.maxValues.map((maxValue, index) => (
                            <option key={`${id}.maxValues.${index}`} value={maxValue}>
                                {trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.max_prefix`)}
                                {maxValue}
                                {trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.max_suffix`)}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        );
    }
}
